// extracted by mini-css-extract-plugin
export const click = "styles-module--click--ZCJhM";
export const picture = "styles-module--picture--geLjp";